<template>
  <div>
    <form id="memoriesForm">
      <TabPanel>
        <app-button-create
          class="border-blue mb-4"
          color="blue"
          type="button"
          @click="showMemoryItemForm()"
        >
          <span class="text-blue font-bold text-lg">経費</span>
          <span class="text-blue font-bold text-sm">を</span>
          <span class="text-blue font-bold text-lg">新規追加</span>
        </app-button-create>
        <div class="flex flex-row border-b border-blue justify-between">
          <div class="mb-2 ml-3">
            <span class="text-blue font-bold text-lg">総支出</span>
          </div>
          <div class="mb-2 mr-3">
            <span class="text-blue font-bold text-lg">
              {{ calcTotalAmount(currentPoliticalAction.memory.expenses) }}
            </span>
          </div>
        </div>
        <div v-if="isShowingMemoryItem">
          <div
            v-for="(item, index) in currentPoliticalAction.memory.expenses"
            :key="'memory-form-expenses-' + index"
            ref="component"
          >
            <MemoryFormItem
              v-if="isShowingMemoryItem"
              :item="item"
              :index="index + 1"
              :length="currentPoliticalAction.memory.expenses.length"
              @show="showMemoryItemForm(item)"
              @remove="removeMemoryFormItem"
            />
          </div>
        </div>
      </TabPanel>
    </form>
    <MemoryFormDialog v-if="isChildOpen" />
  </div>
</template>

<script>
import AppButtonCreate from '@/components/ui/AppButtonCreate'
import MemoryFormItem from '@/components/layout/memory/MemoryFormItem'
import MemoryFormDialog from '@/components/layout/memory/MemoryFormDialog'
import { TabPanel } from '@headlessui/vue'
import { useDialog } from '@/services/useDialog'
import { useMemoryItemForm } from '@/services/politicalAction/useMemoryItemForm'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'

export default {
  name: 'MemoryForm',

  components: {
    TabPanel,
    AppButtonCreate,
    MemoryFormItem,
    MemoryFormDialog,
  },

  setup() {
    const { currentPoliticalAction } = usePoliticalActions()
    const { isShowingMemoryItem } = useMemoryItemForm()

    const calcTotalAmount = expenses => {
      const total = expenses.reduce((total, expense) => {
        const amount = expense?.receipt?.expenseAmount ?? 0
        const numerator = expense?.receipt?.numerator ?? 0
        const denominator = expense?.receipt?.denominator ?? 0
        if (amount === 0) {
          return total
        } else if (numerator === 0 || denominator === 0) {
          return total + amount
        } else {
          return total + prorate(amount, numerator, denominator)
        }
      }, 0)
      return `${total.toLocaleString()}円`
    }

    /**
     * 按分する
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     * @returns number
     */
    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator)
    }

    const showMemoryItemForm = (item) => {
      const { initMemoryItemForm, setMemoryItemForm } = useMemoryItemForm()
      const { openChildDialog } = useDialog()
      const isNewItem = item === null

      if (isNewItem) {
        initMemoryItemForm()
        openChildDialog()
      } else {
        // 既存のデータ読み込み
        setMemoryItemForm(item)
        openChildDialog()
      }
    }

    const removeMemoryFormItem = item => {
      const { removeExpenseFromCurrentPoliticalAction } = useMemoryItemForm()
      removeExpenseFromCurrentPoliticalAction(item)
    }

    return {
      isShowingMemoryItem,
      currentPoliticalAction,
      ...useDialog(),
      calcTotalAmount,
      showMemoryItemForm,
      removeMemoryFormItem,
    }
  },
}
</script>
<style lang="scss"></style>
